var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatisticsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#3545DE",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#3545DE;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}.a{fill-rule:evenodd;}")), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2,2V20a2,2,0,0,0,2,2H22"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    height: 6,
    rx: 1.5,
    width: 3,
    x: 6,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    height: 6,
    rx: 1.5,
    width: 3,
    x: 12,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    height: 6,
    rx: 1.5,
    width: 3,
    x: 18,
    y: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsBlue);
export default __webpack_public_path__ + "static/media/statisticsBlue.388307d9f2731f40207b7337c620efb9.svg";
export { ForwardRef as ReactComponent };